import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
export const sleepAtom = {
  id: 'uicore:sleep',
  name: '延迟',
  category: '逻辑',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'duration',
      type: 'number',
      title: '时长（毫秒）',
      default: 1000
    }]
  },
  execute: (ctx, params) => new Promise(resolve => setTimeout(resolve, Math.floor(params.duration))),
  validateParams(ctxBase, params) {
    if (!isExprObject(params.duration) && !(params.duration > 0)) return '时长（毫秒）不可小于 0';
  }
};
//# sourceMappingURL=sleepAtom.js.map
